import { RequestBuilder } from "../requestBuilder";
import {
  ConceptsWithDistancesSchema,
  ConceptWithDistancesSchema,
  SeedWithDistancesSchema,
} from "./conceptClient.types";
import z from "zod";

export const GetAllConceptsRequestConfig = new RequestBuilder({
  path: () => "/concepts",
  responseSchema: ConceptsWithDistancesSchema,
});

export const GetConceptByIdRequestConfig = new RequestBuilder({
  path: (params) => `/concepts/${params.id}`,
  paramsSchema: z.object({
    id: z.string(),
  }),
  responseSchema: ConceptWithDistancesSchema,
});

export const GetSeedByIdRequestConfig = new RequestBuilder({
  path: (params) => `/concepts/${params.conceptId}/seeds/${params.seedId}`,
  paramsSchema: z.object({
    conceptId: z.string(),
    seedId: z.string(),
  }),
  responseSchema: SeedWithDistancesSchema,
});
